import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
// import Loader from '../loader/loader.jsx'
import s from '../../services/allservices.jsx';
import '../../stylesheet/transfer.css';
import LeftLink from '../leftlink/leftlink.jsx';
import Loader from '../loader/loader.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js'


const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },

    focusTextStyle: {
        color: "#333"
    },
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display,
    profileState: state.getProfileReducer.profileState,
    friendsState: state.getFriendsReducer.friendsState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchFriends() {
        dispatch(
            actions.getFriendsAction()
        )
    }
})
const JSEncrypt = window.JSEncrypt
class LoadToCards extends Component {
    state = {
        toAccount: 1,
        fromAccount: 1,
        transferFrequency: 1,
        amount: "",
        expDate: "",
        firstName: "",
        lastName: "",
        comment: "",
        disabled: true,
        loader: true,
        correctcomment: true,
        commentState: true,
        required: PropTypes.bool,
        amountState: true,
        correctamount: true,
        filteredToCards: [],
        filteredFromCards: []
    }
    componentDidMount() {
        this.setState({
            loader: true
        })
        const { publicKey } = this.props
        let _this = this
        
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }

                _this.props.fetchCard(state)
                _this.props.fetchFriends();
            }
        }, 1000);
        this.setState({
            loader: false,
        })
    }
    removeamount = () => {
        this.setState({
            amountState: true
        })
    }

    onChangeamount = (e, value) => {
        if (e.target.name === "amount") {
            if (/^\d+(\.\d{1,2})?$/.test(e.target.value)) {
                this.setState({
                    correctamount: true,
                    amount: value,
                })
            } else {
                this.setState({
                    correctamount: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    onChangecomment = (e, value) => {
        if (e.target.name === "comment") {
            if (/^[a-zA-Z]$/.test(e.target.value)) {
                this.setState({
                    correctcomment: true,
                    comment: value,
                })
            } else {
                this.setState({
                    correctcomment: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    removecoment = () => {
        this.setState({
            commentState: true
        })
    }
    decimal = (amount) => {
        // var value = Number(amount);
        if (String(amount).split(".").length < 2 || String(amount).split(".")[1].length <= 2) {
            amount = amount.toFixed(2);
        }
        return amount;

    }

    onChange = (e, value) => {

        if (e.target.name === "comment") {


            if (e.target.name === "comment") {
                if (/^[a-zA-Z]$/.test(e.target.value)) {
                    this.setState({
                        correctcomment: true,
                        comment: value,
                    })
                } else {
                    this.setState({
                        correctcomment: false
                    })
                }
            }

            this.setState({
                [e.target.name]: e.target.value
            }, () => {

                const { amount, comment } = this.state

                if (amount !== "" && comment !== "") {

                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }

    }


    handleSelect1 = (event, index, value) => {
        this.setState({ fromAccount: value });
    }
    handleSelect2 = (event, index, value) => {
        this.setState({ toAccount: value });
    }
    handleSelect3 = (event, index, value) => {
        this.setState({ transferFrequency: value });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            loader: true
        })
        try {

            if (nextProps.cardState && nextProps.cardState.length !== 0) {

                var filteredFromR = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "R")
                })
                var filteredFromCards = filteredFromR
                this.setState({
                    loader: false,
                    fromAccount: filteredFromCards[0].cardDetailsId,
                    selectedCard: filteredFromCards[0],
                    filteredFromCards: filteredFromCards
                })
            }
            // if (nextProps.cardState && nextProps.cardState.length !== 0) {
            //     this.setState({
            //         loader: false,
            //         fromAccount: nextProps.cardState.body[0].cardDetailsId
            //     })
            // }
            if (nextProps.friendsState && nextProps.friendsState.length !== 0) {
                this.setState({
                    loader: false,
                    toAccount: nextProps.friendsState.body[0].cardDetailsId,
                    selectedCard: nextProps.friendsState.body[0],
                    filteredToCards: nextProps.friendsState.body
                })
            }
        } catch (e) {

        }
    }
    handleFriends() {
        this.props.history.push("/friends&family")
    }
    handleSubmit = () => {
        const { amount, correctamount } = this.state
        if (amount === "") {
            this.setState({
                amountState: false,
            })
        }
        else if (correctamount === false) {
            this.setState({
                correctamount: false,
            })
        }


        else if (this.state.comment === "") {
            this.setState({
                commentState: false,
            })
        }
        else {
            const { friendsState } = this.props
            let firstName, lastName
            try {
                for (let i = 0; i <= friendsState.body.length; i++) {
                    if (friendsState.body[i].cardDetailsId === this.state.toAccount) {
                        firstName = friendsState.body[i].firstName
                        lastName = friendsState.body[i].lastName
                    }
                }
            } catch (e) {

            }

            const { publicKey } = this.props
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let state = {
                    amount: encrypt.encrypt(this.state.amount),
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    firstName: encrypt.encrypt(firstName),
                    fromCardDetailsId: encrypt.encrypt(this.state.fromAccount),
                    lastName: encrypt.encrypt(lastName),
                    toCardDetailsId: encrypt.encrypt(this.state.toAccount),
                    comments: encrypt.encrypt(this.state.comment)
                }
                let token = "Token " + localStorage.getItem('token')
                if (this.state.toAccount !== this.state.fromAccount) {
                    
                    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
                    let traceId = getClientId();
                    fetch(plink + s.share_fund , {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': token,
                            'X-Trace-Id': traceId,
                            'X-KlickEx-Client':buildClientHeader(),
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201 || response.status === 204) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });

                                setTimeout(function () { window.location.reload(true); }, 1000);

                            }
                            else if (response.status === 422) {
                                if (response.json().length > 0) {
                                    response.json()
                                        .then(json => {
                                            let message = json.message ? json.message : response.headers.get('message')
                                            //document.getElementById('setpassword').style.display = "block"
                                            toast.error(message, {
                                                position: "top-right",
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                                draggablePercent: 60
                                            })
                                        })
                                }
                                else {
                                    let message = response.headers.get('message')
                                    //document.getElementById('setpassword').style.display = "block"
                                    toast.error(message, {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        draggablePercent: 60
                                    })
                                }
                            }
                            else {
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });


                            }
                        })
                } else {
                    toast.error("You cant transfer funds to same card account", {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            }
        }
    }
    render() {
        const { cardState, friendsState } = this.props
        const { fromAccount, toAccount, amountState, correctamount, commentState, filteredFromCards, filteredToCards } = this.state
        console.log("Cardstate" , cardState)
        return (
            <div>
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div className="row">
                    <div className="col-sm-12 p-0 m-0">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{  }}>
                    <div className="row">
                        {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div> */}

                        <div className="col-sm-12" style={{ padding: "0px 30px" }}>

                            <div className="row " style={{ padding: "12px 0px", minHeight: "476px" }}>
                                <div className="col-sm-12 m-0 p-0">
                                    <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                        <h4 className='logmainheading mainheading'>
                                            Load to Card
                                        </h4>
                                        <hr/>
                                        <div className='col-sm-12 p-3' style={{backgroundColor: '#efefef'}}>
                                            <div className='row'>
                                                <div className="col-sm-6">
                                                   <strong> Name on Card :</strong>   {cardState.body[0].firstName}  {cardState.body[0].lastName}
                                                </div>
                                                <div className="col-sm-6">
                                                    <strong>Card Reference ID :</strong>  {cardState.body[0].kitNo}
                                                </div>
                                            </div>
                                        </div>
                                        <h4 className='logmainheading subheading mt-4'>
                                            Loading your Card from a New Zealand Bank Account
                                        </h4>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <p>If you want to load your Card using your own funds, you will need to do so from a New Zealand Bank Account. You must enter the Card Ref Number, as shown above and printed on the back of your Card, as the reference to avoid delays with loading your card. Whilst instructions may differ bank to bank, the following guidelines will help with your transfer.</p>
                                    <p>A fee of $2.00 will be incurred for all bank to card transfers. This fee will be debited from the total transfer amount.</p>
                                    <p><strong>For the first time, you will need to add a new payee.</strong></p>
                                    <ol>
                                        <li>Enter the Bank Name: Oxygen (Oxygen is the Issuer of the Card)</li>
                                        <li>Enter the Account number: 02-0290-0532821-001</li>
                                        <li>Save to payees list</li>
                                    </ol>


                                    <p className='mt-3'><strong>Pay or Transfer</strong></p>
                                    <ol>
                                        <li>Select YOUR account to pay from</li>
                                        <li>Select Oxygen from your Payee list</li>
                                        <li>Enter your full name</li>
                                        <li>Enter the amount you want to transfer</li>
                                        <li>Enter your Prepaid Card Ref number as the payment reference as shown above and printed on the back of your Card.</li>
                                        <li>Confirm transfer details</li>
                                    </ol>

                                    <p>Please allow up to 3 business days for the bank transfer to be credited to your KlickEx Prepaid Card.</p>
                                {/* : <Loader /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LoadToCards.defaultProps = {
    cardState: {
        status: 600
    },
    friendsState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadToCards);


// WEBPACK FOOTER //
// ./src/components/loadcard/loadtocards.jsx